export default __webpack_public_path__ + "static/media/logo-ambientes-bianco.77b530e5.png";